import React from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import useStyles from "../Styles";
import { aboutEntityText } from "../AboutSidebar/AboutTexts";

function GaugePieAboutTab() {
  const { city_selected } = useSelector((state) => state.technical_view);
  const classes = useStyles();
  return (
    <>
      <ChartSidebarAccordion group_name={"About the Visual"} accordion_name={'about'}>
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
          <p>
            This visual shows how physical access to Colorado River water
            changes for {city_selected.name} under the scenario chosen compared
            to current (2020) uses of Colorado River water. The visual gives an
            idea of how municipal use of Colorado River water might be impacted
            by shortages.
          </p>

          <p>
            The outer ring shows the entity&#39;s Colorado River access, and
            moves as access changes. The pie chart shows the entity&#39;s volume
            and use of Colorado River water. The movement of the outer ring next
            to the pie chart indicates which uses of Colorado River water may be
            lost during different levels of shortage.
          </p>

          <p>
            Uses are stacked in the pie chart to indicate that municipal water
            providers may cut aquifer recharge uses first, agriculture uses
            second, turf uses third, exchange uses fourth, and tap water only as
            a last resort. Depending on contracts and agreements, preferences
            for aquifer storage versus creation of long-term storage credits,
            and other factors, municipal water providers may decide to cut uses
            in a different order.{" "}
          </p>
        </Typography>
      </ChartSidebarAccordion>
      <ChartSidebarAccordion group_name={`Entity: ${city_selected.name}`} accordion_name={'entity'}>
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
           {aboutEntityText['CITY'][city_selected.name]? aboutEntityText['CITY'][city_selected.name] : "Information coming soon..."}
        </Typography>
      </ChartSidebarAccordion>
      {/* <ChartSidebarAccordion group_name={`Scenario`}>
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenarioTitle}
        >
          Name of Scenario
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenario}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip
          ex ea com.
        </Typography>
      </ChartSidebarAccordion> */}
    </>
  );
}

export default GaugePieAboutTab;
